var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationMap = function SvgLocationMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "111.9%",
    height: "126.4%",
    x: "-5.9%",
    y: "-11.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.208397072 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#a)",
    transform: "translate(10 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.5,
    height: 39.5,
    x: 0.25,
    y: 0.25,
    fill: "#FFF",
    stroke: "#E6E6E6",
    strokeWidth: 0.5,
    rx: 19.75
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "m15.875 17.25-4.125 1.833L9 31l5.958-3.208z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D8D7",
    d: "m20 19.083-4.125-1.833-.917 10.542L20 31V19.083zm4.125-1.833 4.125 1.833L31 31l-5.958-3.208-.917-10.542z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "m20 19.083 4.125-1.833.917 10.542L20 31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20A4F8",
    d: "M20 9a5.958 5.958 0 0 0-5.958 5.958c.023.881.219 1.748.577 2.553 1.407 3.406 5.381 7.53 5.381 7.53s3.97-4.124 5.376-7.53a6.71 6.71 0 0 0 .582-2.553A5.958 5.958 0 0 0 20 9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.792 14.958a3.208 3.208 0 1 0 6.416 0 3.208 3.208 0 0 0-6.416 0z"
  })))));
};
export default SvgLocationMap;